module.exports = __webpack_public_path__ + "img/10.48c0a592.png";